<div class="dialog">
  @if(data.title) {
    <header class="dialog__header">
      <ci-icon 
        class="dialog__icon"
        type="svg" 
        [name]="data.iconName"
        scale="1.5x"
      ></ci-icon>
        
      <h2 class="dialog__title ci-subheading-semibold">
        {{ data.title | translate }}
      </h2>
    </header>
  }
    
  @if (data.content) {
    <main class="dialog__main">
      <p 
        [innerHTML]="data.content | translate"
        class="ci-paragraph-p1-regular"
      ></p>
    </main>
  }
  
  @if (data.handleClickPrimaryButton || data.handleClickSecondaryButton) {
    <footer class="dialog__footer">
      @if (data.secondaryActionButtonText) {
        <ci-text-button 
          class="dialog__secondary-text-button"
          class-name="ci-text-btn-primary-s" 
          type="button" 
          [attr.aria-label]="data.secondaryActionButtonText | translate"
          (click)="data.handleClickSecondaryButton()"
        >
          {{ data.secondaryActionButtonText | translate }}
        </ci-text-button>
      }
        
      @if (data.handleClickPrimaryButton) {
        <ci-text-button 
          class="dialog__primary-text-button"
          class-name="ci-text-btn-primary-s" 
          type="button" 
          [attr.aria-label]="data.primaryActionButtonText | translate"
          (click)="data.handleClickPrimaryButton()"
        >
          {{ data.primaryActionButtonText| translate }}
        </ci-text-button>
      }
    </footer>
  }
</div>